module.exports = __webpack_public_path__ + "static/Laser dentistry intraoral before-19f2f1413d2fde71bb64a2fcc8628193.jpg";